/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6debd57b02ce07c26b500a40c5cf84fa>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/commit';
import NewObjectComponent from '@atlaskit/object/commit';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/commit/16';

/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Commit16Icon = function Commit16Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  // Feature flag to migrate to new object package
  if (fg('platform_dst_icon_object_to_object')) {
    // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/React.createElement(NewObjectComponent, {
      label: label,
      testId: testId,
      size: "medium"
    });
  }
  return /*#__PURE__*/React.createElement(IconTile, {
    icon: NewIcon,
    appearance: "orangeBold",
    size: "16",
    label: label,
    testId: testId,
    LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    })
  });
};
Commit16Icon.displayName = 'Commit16Icon';
export default Commit16Icon;